module.exports = __webpack_public_path__ + "static/whyX-41127e95b7f026bd9770fbb0f213ac11.png";